import { parseISO } from 'date-fns';
import React, { ChangeEvent, useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';

import { BootstrapSwitchButton, CreatableSelectDB } from '../../formik';
import SelectDB, { OptionType } from '../../select-db';
//import SelectDB, { OptionType } from 'motion-components/lib/common/select-db';
//import { BootstrapSwitchButton } from 'motion-components';
//import CreatableSelectDB from './creatable-select-db';

export const TableCellV8 = (props) => {
  const { getValue, row, column, table } = props;
  const initialValue = getValue();
  const columnMeta = column.columnDef.meta;
  const tableMeta = table.options.meta;
  const [value, setValue] = useState(initialValue);
  const [validationMessage, setValidationMessage] = useState('');

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const onBlur = (e: ChangeEvent<HTMLInputElement>) => {
    console.log(
      `$$$ updateData onBlur row=${row.index} ${
        column.id
      }=${value} ${typeof value}`
    );
    displayValidationMessage(e);
    tableMeta.updateData(row.index, column.id, value, row); //.target.validity.valid);
  };

  // for Input component
  const onValueChange = (e) => {
    if (columnMeta?.type === 'numeric') {
      setValue(Number(e.target.value));
    } else setValue(e.target.value);

    // propagate changes
    if (columnMeta.onValueChange) {
      columnMeta.onValueChange(e.target.value, row);
    }
  };

  const onSelectChange = (selectedOption: OptionType) => {
    const value = selectedOption.value;
    const name = selectedOption.label;
    setValue(value);
    tableMeta.updateData(row.index, columnMeta?.idKey, value, row);
    tableMeta.updateData(row.index, columnMeta?.idName, name, row);

    // propagate changes
    if (columnMeta.onValueChange) {
      columnMeta.onValueChange(value, { ...row, valueName: name });
    }
  };

  const onCreatableSelectChange = (selectedOption: OptionType) => {
    const value = selectedOption.value;
    setValue(value);
    tableMeta.updateData(row.index, columnMeta?.idKey, value, row);

    // propagate changes
    if (columnMeta.onValueChange) {
      columnMeta.onValueChange(value, row);
    }
  };

  const onDateChange = (date: Date) => {
    console.log('$$$ updateData onDateChange', date);
    const newValue = date.toISOString();
    setValue(newValue);
    tableMeta.updateData(row.index, column.id, newValue, row); //.target.validity.valid);

    // propagate changes
    if (columnMeta.onValueChange) {
      columnMeta.onValueChange(value, row);
    }
  };

  const onCheckboxChange = (checked) => {
    console.log('$$$ updateData onCheckboxChange', checked);
    setValue(checked);
    tableMeta.updateData(row.index, column.id, checked, row); //.target.validity.valid);

    // propagate changes
    if (columnMeta.onValueChange) {
      columnMeta.onValueChange(value, row);
    }
  };

  const displayValidationMessage = <
    T extends HTMLInputElement | HTMLSelectElement
  >(
    e: ChangeEvent<T>
  ) => {
    if (columnMeta?.validate) {
      const isValid = columnMeta.validate(e.target.value);
      if (isValid) {
        e.target.setCustomValidity('');
        setValidationMessage('');
      } else {
        e.target.setCustomValidity(columnMeta.validationMessage);
        setValidationMessage(columnMeta.validationMessage);
      }
    } else if (e.target?.validity?.valid) {
      setValidationMessage('');
    } else {
      setValidationMessage(e.target?.validationMessage ?? '');
    }
  };

  const valueOfKey = (obj: object, key: string) => {
    if (!key) return '';
    if (key.indexOf('.') > 0) {
      const frsPart = key.split('.')[0];
      const secPart = key.split('.')[1];

      return obj[frsPart]?.[secPart];
    } else return obj[key];
  };

  const nameValue = valueOfKey(row.original, columnMeta?.idName);

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      // Prevent any action on Enter key press
      e.preventDefault();
    }
  };

  if (tableMeta?.editedRows[row.id]) {
    return columnMeta?.type === 'creatableselect' ? (
      <CreatableSelectDB
        id={columnMeta?.idKey}
        hook={columnMeta?.hook}
        where={columnMeta?.where}
        placeholder={''}
        value={initialValue}
        label={''}
        onChange={onCreatableSelectChange}
      />
    ) : columnMeta?.type === 'select' ? (
      <SelectDB
        id={columnMeta?.idKey}
        hook={columnMeta?.hook}
        where={columnMeta?.where}
        placeholder={''}
        value={initialValue}
        label={nameValue}
        onChange={onSelectChange}
      />
    ) : columnMeta?.type === 'datepicker' ? (
      <DatePicker
        id={columnMeta?.idKey}
        className="form-control"
        autoComplete="off"
        preventOpenOnFocus
        placeholderText={columnMeta?.placeholder}
        dateFormat={columnMeta?.dateFormat ?? 'dd/MM/yyyy'}
        selected={typeof value === 'string' ? parseISO(value) : value}
        onChange={onDateChange}
        // onBlur={onBlur}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        disabled={columnMeta?.disabled}
        required={columnMeta?.required}
        minDate={columnMeta?.minDate}
        maxDate={columnMeta?.maxDate}
        filterDate={
          columnMeta?.disableWeekend ? columnMeta?.isWeekday : undefined
        }
        dayClassName={columnMeta?.handleDateColor}
        {...columnMeta?.rest}
      />
    ) : columnMeta?.type === 'checkbox' ? (
      <div className="text-center">
          <BootstrapSwitchButton

          id={columnMeta?.idKey}
          checked={value || false}
          onlabel={columnMeta?.onLabel ?? 'ΝΑΙ'}
          offlabel={columnMeta?.offLabel ?? 'ΟΧΙ'}
          width={columnMeta?.width}
          onChange={onCheckboxChange}
          onstyle={
            columnMeta?.onStyle
              ? columnMeta?.onStyle
              : columnMeta?.disabled
              ? 'dark'
              : 'primary'
          }
          offstyle={
            columnMeta?.offStyle
              ? columnMeta?.offStyle
              : columnMeta?.disabled
              ? 'light'
              : 'warning'
          }
                disabled={columnMeta?.disabled}
                size="sm"
        />
      </div>
    ) : (
      <input
        className="form-control"
        value={value}
        onKeyDown={columnMeta?.noEnter ? onKeyDown : undefined}
        onChange={onValueChange}
        onBlur={onBlur}
        type={columnMeta?.type || 'text'}
        required={columnMeta?.required}
        pattern={columnMeta?.pattern}
        title={validationMessage}
        disabled={columnMeta?.disabled}
      />
    );
  } else {
    const displayValue =
      value == null
        ? ''
        : typeof value === 'object'
        ? JSON.stringify(value)
        : String(value);
    return columnMeta?.type === 'select' ? (
      <span>{nameValue ?? ''}</span>
    ) : columnMeta?.viewCell ? (
      columnMeta?.viewCell(props)
    ) : (
      <span>{displayValue}</span>
    );
  }
};
